import React, { useState, useEffect, memo } from "react";
import styles from "../Layout.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchSettings,
  fetchNotification,
  fetchPromotions,
} from "../../../features/settings/settingsSlice";
import { OfferList } from "../../../features/products/offerSlice";
import { userActive } from "../../../features/users/usersSlice";
import { getCartItems } from "../../../features/cart/cartSlice";
import { getOfferProducts } from "../../../features/products/productsSlice";
import Logo from "../../assets/images/tugo-logo-light.svg";
import LoginImg from "../../assets/images/login-ico.png";
import DarkLoginImg from "../../assets/images/dark-login-ico.png";
import { useTranslation, Trans } from "react-i18next";
import { setStorage, getStorage } from "../../utilityfunctions";
import MinimumOrderAmountPopup from "../../../features/cart/minimumOrderAmountPopup";

const Header = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const accountName = JSON.parse(getStorage("authData"))
    ? JSON.parse(getStorage("authData")).accountName
    : "";
  const [cartCount, setCartCount] = useState(0);
  const [cartAmount, setCartAmount] = useState(0);
  const [minimumCartPopup, setMinimumCartPopup] = useState(false);
  const [notificationShow, setNotificationShow] = useState(true);
  const [notificationAccepted, setnotificationAccepted] = useState(() => {
    return getStorage("notification_close") ?? "No";
  });

  const { t } = useTranslation(); // Used Translation file
  /* Using Redux Toolkit */

  const { sitesettings, notification, status, notificationstatus,promotions, promotionStatus} =
    useSelector((state) => state.sitesettings);
  const { offerlist, status: offerStatus } = useSelector(
    (state) => state.offerlist
  );
  const { offerProductList } = useSelector((state) => state.products);

  const { cartItems, status: cartStatus } = useSelector((state) => state.cart);
  const { userActive: userDetails, activeStatus } = useSelector(
    (state) => state.users
  );
  var authData = {};
  if (getStorage("authData")) {
    authData = JSON.parse(getStorage("authData"));
  }
  if (activeStatus === "succeeded") {
    if (userDetails?.data?.accountStatus === 'deactive') {
      window.location.href = "/logout";
    }
  }

  let hasSettings = false;
  let hasNotification = false;
  let hasPromotions = false;
  let minimumOrderAmount = "";
  let minimumOrderamt = 0;
  if (status === "succeeded") {
    hasSettings =
      sitesettings && sitesettings?.data && sitesettings?.data.length > 0;
    if (sitesettings.data[0].maintananceMode === "1") {
      navigate("/sitemaintenance");
    }

    let minimumamt = authData?.minimumOrderAmount;
    //console.log(minimumamt,'minimumamt');
    if (minimumamt !== "" && typeof minimumamt !== "undefined") {
      minimumOrderamt = minimumamt;
    } else {
      minimumOrderamt =
        hasSettings && sitesettings?.data[0]?.minimumOrderAmount;
    }
    minimumOrderAmount = (
      <Trans
        i18nKey="minimumorderalert_txt"
        values={{ amount: parseInt(minimumOrderamt) }}
      />
    );
  }

  if (notificationstatus === "succeeded") {
    hasNotification =
      notification && notification?.data && notification?.data.length > 0;
  }

  if (promotionStatus === "succeeded") {
    hasPromotions =
      promotions && promotions?.data && promotions?.data.length > 0;
  }

  useEffect(() => {
    if (getStorage("isLoggedIn") && getStorage("uuid") !== null && cartStatus === "succeeded") {
      let payload = {
        uuid: getStorage("uuid"),
      };
      dispatch(userActive(payload));
    }
  }, [cartStatus]);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchSettings());
    }
  }, [status, dispatch]);

  useEffect(() => {
    const loginDetails = JSON.parse(getStorage("authData")) || {};

    if (
      getStorage("isLoggedIn") &&
      offerStatus === "idle" &&
      loginDetails.accountObjective1 !== "0" &&
      loginDetails.accountObjective2 !== "0"
    ) {
      dispatch(OfferList());
    }

    if (getStorage("isLoggedIn") && notificationstatus === "idle") {
      dispatch(fetchNotification());
    }
    
    if (getStorage("isLoggedIn") && promotionStatus === "idle") {
        dispatch(fetchPromotions());
      }
          
    
  }, [offerStatus, notificationstatus,promotionStatus, dispatch]);

  useEffect(() => {
    if (offerlist?.data?.length > 0 && offerlist?.data?.length === 1) {
      const productToBeAdded = offerlist?.data[0].productToBeAdded;
      const productToBeAddedArr = productToBeAdded.split(",");
      const uniqueProducts = [...new Set(productToBeAddedArr)];

      if (getStorage("isLoggedIn") && uniqueProducts.length > 0) {
        const productsId = { $in: uniqueProducts };
        const payload = {
          productIds: productsId,
          priceband: getStorage("priceband"),
        };
        dispatch(getOfferProducts(payload));
      }
    } else if (offerlist?.data?.length > 1) {
      const productToBeAdded1 = offerlist?.data[0].productToBeAdded;
      const productToBeAdded2 = offerlist?.data[1].productToBeAdded;
      const productToBeAddedArr1 = productToBeAdded1.split(",");
      const productToBeAddedArr2 = productToBeAdded2.split(",");
      const productToBeAddedArr =
        productToBeAddedArr1.concat(productToBeAddedArr2);
      const uniqueProducts = [...new Set(productToBeAddedArr)];
      if (getStorage("isLoggedIn") && uniqueProducts.length > 0) {
        const productsId = { $in: uniqueProducts };
        const payload = {
          productIds: productsId,
          priceband: getStorage("priceband"),
        };
        dispatch(getOfferProducts(payload));
      }
    }
  }, [dispatch, offerlist]);

  /* end Redux Toolkit */

  useEffect(() => {
    if (getStorage("isLoggedIn")) {
      dispatch(getCartItems());
    }
  }, [dispatch]);

  useEffect(() => {
    if (cartStatus === "succeeded" && cartItems.length > 0) {
      let QtySum = 0;
      var cartTotal = 0;
      var totalAmount = 0;
      var TaxAmount = 0;
      if (cartItems.length > 0) {
        cartItems.map((item) => {
          if (item.qty > 0) {
            QtySum += item.qty;
            cartTotal += parseFloat(item.itemPrice) * item.qty;
          }
          if (item.vat > 0) {
            totalAmount += item.itemPrice * item.qty;
          }
        });
      }
      if (totalAmount > 0) {
        TaxAmount = (totalAmount / 100) * 20;
        cartTotal = cartTotal + TaxAmount;
      }

      if (cartTotal) {
        setCartAmount(cartTotal);
      }
      setStorage("cartquantity", cartItems.length);
      setCartCount(QtySum);
    } else {
      setCartAmount(0);
      setCartCount(0);
    }
  }, [cartItems, cartStatus]);

  useEffect(() => {
    var cookieChecked = getStorage("cookie_accepted");
    if (
      cookieChecked === "" ||
      cookieChecked === null ||
      cookieChecked === "null"
    ) {
      document.body.classList.add("cookies-on");
    }
  }, []);
  useEffect(() => {
    const notificationshow = getStorage("notification_close");
    if (
      notificationshow === "" ||
      notificationshow === null ||
      notificationshow === "null"
    ) {
      const bodyclasses =
        hasNotification &&
          notification?.data[0]?.enablenotification === "1" &&
          notification?.data[0]?.notificationDesktop === "header" &&
          notification?.data[0]?.notificationResponsive === "popup"
          ? "popup-mobile"
          : hasNotification &&
            notification?.data[0]?.enablenotification === "1" &&
            notification?.data[0]?.notificationDesktop === "popup" &&
            notification?.data[0]?.notificationResponsive === "header"
            ? "popup-desktop"
            : hasNotification &&
              notification?.data[0]?.enablenotification === "1" &&
              notification?.data[0]?.notificationDesktop === "popup" &&
              notification?.data[0]?.notificationResponsive === "popup"
              ? "popup-all"
              : "";
      hasNotification &&
        bodyclasses != "" &&
        document.body.classList.add(bodyclasses);
    }
    if (notificationshow) {
      setnotificationAccepted(notificationshow);
      setNotificationShow(false);
    }
  }, [hasNotification]);

  const notificationPopClose = (e) => {
    e.preventDefault();

    var notificationshow = getStorage("notification_close");

    if (
      notificationshow == "" ||
      notificationshow === null ||
      notificationshow == "null"
    ) {
      setStorage("notification_close", "Yes");
      setnotificationAccepted("Yes");
      setNotificationShow(false);

      const bodyclasses =
        hasNotification &&
          notification?.data[0]?.notificationDesktop === "header" &&
          notification?.data[0]?.notificationResponsive === "popup"
          ? "popup-mobile"
          : hasNotification &&
            notification?.data[0]?.notificationDesktop === "popup" &&
            notification?.data[0]?.notificationResponsive === "header"
            ? "popup-desktop"
            : hasNotification &&
              notification?.data[0]?.notificationDesktop === "popup" &&
              notification?.data[0]?.notificationResponsive === "popup"
              ? "popup-all"
              : "";

      document.body.classList.remove(bodyclasses);
    }
  };

  const HomeRedirection = () => {
    navigate("/home");
  };

  const checkredirection = () => {
    var siteUrlPage = window.location.pathname.split("/");
    if (siteUrlPage[1] !== "checkout") {
      setStorage("minimumOrderAmounterror", "Yes");
      //navigate("/product/pizza");
      setMinimumCartPopup(true);
    }
  };

  var siteUrlPage = window.location.pathname.split("/").pop();

  const isLoggedIn = getStorage("isLoggedIn");
  const enableNotification =
    hasNotification && notification?.data[0]?.enablenotification === "1";
  const desktopNotification =
    hasNotification && notification?.data[0]?.notificationDesktop;
  const responsiveNotification =
    hasNotification && notification?.data[0]?.notificationResponsive;

  const textaligndesktop =
    hasNotification && notification?.data[0]?.textalignDesktop;
  const textalignresponsive =
    hasNotification && notification?.data[0]?.textalignResponsive;

  const shouldShowNotification =
    isLoggedIn &&
    enableNotification &&
    notificationShow &&
    notificationAccepted !== "Yes";

  // Calculate classes based on conditions
  const classes =
    enableNotification &&
      desktopNotification === "header" &&
      responsiveNotification === "popup"
      ? "notification-Popup popup-mobile"
      : enableNotification &&
        desktopNotification === "popup" &&
        responsiveNotification === "header"
        ? "notification-Popup popup-desktop"
        : enableNotification &&
          desktopNotification === "popup" &&
          responsiveNotification === "popup"
          ? "notification-Popup popup-all"
          : "";

  const alignmentClass = [
    textaligndesktop === "left" ? "text-left-desktop" : "",
    textalignresponsive === "left" ? "text-left-mob" : "",
    textaligndesktop === "center" ? "text-center-desktop" : "",
    textalignresponsive === "center" ? "text-center-mob" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <header>
        {shouldShowNotification && (
          <div className={`hdr-notification-bar ${classes} ${alignmentClass}`}>
            <div className="notification-overlay"></div>
            <div className="notification-content">
              <span
                className="close-bar"
                onClick={(e) => notificationPopClose(e)}
              ></span>
              <div className="notify-txt">
                <span className="icon">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
                <p>{notification?.data[0]?.notification_txt}</p>
              </div>

              <div className="notification-buttons">
                <a
                  className="button ok-btn"
                  title={t("ok_btntxt")}
                  onClick={(e) => notificationPopClose(e)}
                >
                  {t("ok_btntxt")}
                </a>
              </div>
            </div>
          </div>
        )}

        <div className="sm-container">
          <div className={styles.headFlx}>
            <a className={styles.logo} onClick={HomeRedirection} title="TUGO">
              <img src={Logo} alt="TUGO" />
            </a>
            <p className={styles.headTxt}>
              {t("SiteTitle")}
              <span className="subhead">{t("SubTitle")}</span>
              <span className="title-desc">{t("SubTitle2")}</span>
            </p>
            <div className={styles.headRight}>
              <div className={styles.rgtFlx}>
                {/* Login In Start */}

                {accountName && (
                  <a href={void 0} className={styles.acc}>
                    <span className={styles.headLog}>
                      <span className={styles.logicon}>
                        <img className={styles.nrm} src={LoginImg} />
                        <img className={styles.hov} src={DarkLoginImg} />
                      </span>
                      <span className={styles.logName}>
                        {t("Account_txt")}{" "}
                      </span>
                      <span className={styles.logarrow}>
                        <i className={`fa fa-angle-down ${styles.icon}`}></i>
                      </span>
                    </span>
                    <div className={styles.logout}>
                      <span>
                        <Link to="/account" title={t("OrderMenu_txt")}>
                          <i
                            className={`fa fa-shopping-cart ${styles.ico}`}
                          ></i>
                          {t("OrderMenu_txt")}
                        </Link>
                      </span>
                      <span>
                        <Link to="/myaccount" title={t("AccountMenu_txt")}>
                          <i className={`fa fa-user ${styles.ico}`}></i>
                          {t("AccountMenu_txt")}
                        </Link>
                      </span>
                      <span>
                        <Link
                          to="/changepassword"
                          title={t("ChangepassMenu_txt")}
                        >
                          <i className={`fa fa-key ${styles.ico}`}></i>
                          {t("ChangepassMenu_txt")}
                        </Link>
                      </span>
                      {offerProductList !== undefined &&
                        offerProductList.length > 0 && (
                          <span>
                            <Link to="/offerinfo" title={t("special_offertxt")}>
                              <i className={`fa fa-bullhorn ${styles.ico}`}></i>
                              {t("special_offertxt")}
                            </Link>
                          </span>
                        )}
                      
                      {getStorage("isLoggedIn") && promotions?.data?.some(promo => promo.InDownloads) && (userDetails?.data?.accountPriceListId != 'TRIP' && userDetails?.data?.accountPriceListId != 'DUKE' && userDetails?.data?.accountPriceListId != 'DUKE P' ) && (
                        <span>
                        <Link
                          to="/downloads"
                          title={t("download_txt")}
                        >
                          <i className={`fa fa-download ${styles.ico}`}></i>
                          {t("download_txt")}
                        </Link>
                      </span>)}
                      {getStorage("isLoggedIn") && promotions?.data?.length > 0 && (userDetails?.data?.accountPriceListId != 'TRIP' && userDetails?.data?.accountPriceListId != 'DUKE' && userDetails?.data?.accountPriceListId != 'DUKE P') && (
                        <span>
                        <Link
                          to="/monthlypromotions"
                          title={t("monthly_promotions_txt")}
                        >
                          <i className={`fa fa-archive ${styles.ico}`}></i>
                          {t("monthly_promotions_txt")}
                        </Link>
                      </span>
                       )} 
                      <span>
                        <Link to="/logout" title={t("Logout_txt")}>
                          <i className={`fa fa-sign-out ${styles.ico}`}></i>
                          {t("Logout_txt")}
                        </Link>
                      </span>
                    </div>
                  </a>
                )}

                {!accountName && (
                  <Link to="/">
                    <span className={styles.headLog}>
                      <span className={styles.logicon}>
                        <img className={styles.nrm} src={LoginImg} />
                        <img className={styles.hov} src={DarkLoginImg} />
                      </span>
                      <span className={styles.logName}>{t("Login_txt")} </span>
                    </span>
                  </Link>
                )}

                <div className={styles.cartHolder}>
                  {accountName &&
                    cartCount > 0 &&
                    hasSettings &&
                    cartCount < minimumOrderamt &&
                    cartAmount < minimumOrderamt &&
                    siteUrlPage !== "sitemaintanance" && (
                      <a
                        className={styles.cartIco}
                        onClick={checkredirection}
                        title={t("cart_items_txt")}
                      >
                        <span className={styles.count}>{cartCount}</span>
                        <i
                          className={`fa fa-shopping-cart ${styles.faIco}`}
                        ></i>
                      </a>
                    )}

                  {accountName &&
                    cartCount > 0 &&
                    hasSettings &&
                    cartAmount >= minimumOrderamt &&
                    siteUrlPage !== "sitemaintanance" && (
                      <Link
                        to="/checkoutpay"
                        className={styles.cartIco}
                        title={t("cart_items_txt")}
                      >
                        <span className={styles.count}>{cartCount}</span>
                        <i
                          className={`fa fa-shopping-cart ${styles.faIco}`}
                        ></i>
                      </Link>
                    )}
                </div>
              </div>

              {/* Login In End */}

              {/* <Link
                to={`tel: ${t("telephone_text")}`}
                className={styles.headLink} title={t("telephone_text")}
              >
                <i className="fa fa-phone" aria-hidden="true" />
                {t("telephone_text")}
              </Link>
              <Link
                to={`mailto: ${t("email_text")}`}
                className={styles.headLink} title={t("email_text")}
              >
                <i className="fa fa-envelope" />
                {t("email_text")}
              </Link> */}
            </div>
          </div>
        </div>
      </header>
      {minimumCartPopup && (
        <MinimumOrderAmountPopup
          popupClose={setMinimumCartPopup}
          minmumAmount={minimumOrderAmount}
        />
      )}
    </>
  );
};
export default memo(Header);
